// extracted by mini-css-extract-plugin
export default {"actionsCell":"productMenuListItem_actionsCell__3VjPg","dropdownMenu":"productMenuListItem_dropdownMenu__j7hGB"};